import moment from "moment";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";

import { Button } from "@/components/ui/button";
import { InputGroup } from "@/components/ui/input";
import {
  exportSOTMachineCM,
  exportSOTMachineOTH,
  exportSOTMachinePM,
  fetchApi,
  getAuthCustomer,
  optionRole,
  serviceType,
} from "@/helpers/h";
import { useData } from "@/stores/data";
import { useModal } from "@/stores/modal";
import { useState } from "react";
import { SelectGroup } from "@/components/ui/select";
import { useCustomerOptions } from "@/queries";

export default function ExportMachine() {
  const { close } = useModal();
  const { loading, setLoading } = useData();
  const { options: customerOptions, isLoading: isCustomersLoading } =
    useCustomerOptions();
  const [filter, setFilter] = useState({
    service_type: "",
    month_year: moment().format("YYYY-MM"),
    role: [],
    customer_id: null,
  });
  // const { data, isLoading } = useFetch({
  //   url:
  //     "/machine?" +
  //     new URLSearchParams({
  //       withSot: 1,
  //       withCustomer: 1,
  //       withServiceEngineer: 1,
  //       withPartRequests: 1,
  //       service_type: filter?.service_type,
  //       month_year: filter?.month_year,
  //       role: filter?.role,
  //     }),
  //   method: "GET",
  //   condition: filter?.service_type && filter?.month_year && filter?.role?.length > 0,
  //   dep: [filter?.service_type, filter?.month_year, filter?.role],
  // });
  const handleExport = async () => {
    if (!filter.service_type) return toast.error("Service Type is required");
    let excelData;
    setLoading(true);
    const res = await fetchApi({
      url:
        "/machine?" +
        new URLSearchParams({
          withSot: 1,
          withCustomer: 1,
          withServiceEngineer: 1,
          withPartRequests: 1,
          service_type: filter?.service_type,
          month_year: filter?.month_year,
          role: filter?.role,
          customer_ids: filter.customer_id
            ? filter.customer_id
            : getAuthCustomer().length > 0
              ? getAuthCustomer()
                  .map((obj) => obj.id)
                  .join(",")
              : "",
        }),
      method: "GET",
    });

    if (filter.service_type === "CM") {
      excelData = exportSOTMachineCM(res?.data?.data || [], filter);
    }
    if (filter.service_type === "PM") {
      excelData = exportSOTMachinePM(res?.data?.data || [], filter);
    }
    if (filter.service_type === "OTH") {
      excelData = exportSOTMachineOTH(res?.data?.data || [], filter);
    }

    // Convert to Excel
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Machine Data");

    // Generate filename
    const filename = `${
      filter.role?.length > 0
        ? filter.role?.length == 1
          ? filter.role.includes("flm")
            ? "flm"
            : filter.role.includes("cit")
              ? "cit"
              : filter.role.includes("cv")
                ? "cv"
                : "se"
          : filter.role.join("_")
        : ""
    }_machine_${filter.service_type}_sot_${moment().format(
      "hhmm_DDMMYYYY",
    )}.xlsx`;

    // Download Excel file
    XLSX.writeFile(wb, filename);
    setLoading(false);
  };
  return (
    <div className="flex flex-col gap-[20px] bg-white rounded-[8px] md:rounded-[12px] lg:rounded-[16px] p-[24px] max-h-[90dvh] overflow-y-auto overflow-x-hidden">
      <h2 className="font-bold md:w-[500px] text-[24px]">Export SOT</h2>
      <SelectGroup
        label="Service Service Type"
        menuPosition="fixed"
        isClearable
        isDisabled={!serviceType || loading}
        placeholder="Select Service Service Type"
        className="w-full"
        options={serviceType}
        value={serviceType.find((obj) => {
          return obj.value == filter.service_type;
        })}
        onChange={(e) => {
          setFilter({
            ...filter,
            service_type: e?.value,
          });
        }}
      />
      <InputGroup
        label="Month/Year"
        type="month"
        value={filter?.month_year || ""}
        disabled={loading}
        onChange={(e) => {
          setFilter({
            ...filter,
            month_year: e.target.value,
          });
        }}
      />
      <SelectGroup
        label="Customer"
        menuPosition="fixed"
        isClearable
        isDisabled={isCustomersLoading || loading}
        placeholder="Select Customer"
        className="w-full"
        options={customerOptions}
        value={
          customerOptions &&
          customerOptions.find((obj) => obj.value === filter.customer_id)
        }
        onChange={(e) => {
          setFilter({
            ...filter,
            customer_id: e ? e.value : null,
          });
        }}
      />
      <SelectGroup
        label="Service Assigned Person Type"
        menuPosition="fixed"
        isClearable
        isMulti
        isDisabled={!optionRole || loading}
        placeholder="Select Service Assigned Person Type"
        className="w-full"
        options={optionRole}
        value={optionRole.filter((obj) => {
          return filter.role?.includes(obj.value);
        })}
        onChange={(e) => {
          setFilter({
            ...filter,
            role: e?.map((obj) => obj.value) || [],
          });
        }}
      />
      <div className="flex gap-2 flex-col md:flex-row gap-3 justify-end">
        <Button variant="gray" onClick={close} isLoading={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleExport} isLoading={loading}>
          Export to Excel
        </Button>
      </div>
    </div>
  );
}
